import { SuperClusterConfigOptions } from '../types'

const BASE_URL = '/services/plugin-clustermanager/cluster-manager/'

export const getConfig = async (): Promise<{ data: SuperClusterConfigOptions; success: boolean }> => {
    const response = await fetch(BASE_URL)
    return response.json()
}

export const postConfig = async (
    parameters: SuperClusterConfigOptions
): Promise<{ data: SuperClusterConfigOptions; success: boolean }> => {
    const response = await fetch(BASE_URL, {
        method: 'POST',
        headers: {
            origin: 'same-origin',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(parameters)
    })

    return response.json()
}

export const getLiveUsers = async id => {
    return await fetch(`/rest/user/${id}`).then(response => response.json())
}
